import { StringObj } from "./type";

export const pages: StringObj[] = [
  { id: "top", label: "Top" },
  { id: "generate", label: "作成" },
  { id: "review", label: "チェック" },
  { id: "format", label: "フォーマット修正" },
];

export const color = {
  background: "#F8F8F7",
  background2: "#FFFFFF",
  border: "#E5E5E5",
  border2: "#A9A9A9",
  borderFocus: "#3b82f6",
  tableHeader: "#5C7484",
  // chartRedGrad: ["#E15041", "#E78B7D", "#D90000", "#E7BEB8", "#990000"],
  // chartGrayGrad: [grey[400], grey[300], grey[500], grey[200]],
  // chartColors: [
  //   "#389BAC",
  //   "#009917",
  //   "#DCA801",
  //   "#EA692A",
  //   "#E83839",
  //   "#648DB1",

  //   "#77C9D7",
  //   "#C3ECDF",
  //   "#FFD657",
  //   "#F9AA83",
  //   "#FE8989",
  //   "#9CBFDE",

  //   "#64A9B6",
  //   "#4FA846",
  //   "#E1B345",
  //   "#EE824F",
  //   "#DC6C5D",
  //   "#7E9DBA",
  // ],
  positive: "#64A9B6",
  negative: "#ED6357",
};

export const questionTypes = [
  "SA",
  "MA",
  "SAマトリクス",
  "MAマトリクス",
  "MAマトリクス（絞込有）",
  "MASA混在マトリクス",
  "FA（自由回答）",
  "NA（数値回答）",
  "TX（文字回答）",
  "性別",
  "年齢",
  // "MAマトリクス(絞込有)",
  // "MAﾏﾄﾘｸｽ(絞込有)",
  // "MASA混在ﾏﾄﾘｸｽ",
  // "FA(自由回答)",
  // "NA(数値回答)",
  // "TX(文字回答)",
];

export const randomValues = [
  "",
  "なし",
  "固定",
  "ランダム",
  "G間ランダム",
  "G内ランダム",
  "G内&G間ランダム",
  "G内昇降順",
  "G間昇降順",
  "G内&G間昇降順",
  "G内ランダム＆G間昇降順",
  "G内昇降順＆G間ランダム",
  "昇順",
  "降順",
  "昇順降順",
  "昇順降順",
];

export const questionKeyLabels: StringObj = {
  questionId: "設問ID",
  questionType: "回答形式",
  questionText: "設問文",
  loop: "マトリクス行項目",
  options: "選択肢",
  // rowType: "行タイプ",
  // itemId: "項目ID",
  exclusive: "排他設定",
  condition: "表示条件",
  creative: "画像・動画",
  random: "並び替え設定",
  answerType: "マトリクス回答形式",
  remarks: "備考",
  questionTitle: "設問タイトル",
  questionSupplementPrev: "設問補足文（前）",
  questionSupplement: "設問補足文",
  whole_questions: "全体設計",
};
